export const roomTypeData = [
    {key: 'all', text: 'Evet', value: 'all'},
    {key: 'false', text: 'Hayır', value: 'false'},

];